import { IApiUserClientSideTranslationKey } from '@api/services/user/clientSideTranslations/clientSideTranslation.apiService.interfaces';
import { apiUserClientSideTranslations } from '@api/services/user/clientSideTranslations/clientSideTranslations.apiService';
import { keyMap } from '@locales/lokalise/keyMap';
import { handleError } from '@utils/errors';
import { makeAutoObservable, runInAction } from 'mobx';
import { MobxRootStore } from './mobx.store';

export class ClientSideTranslation {
  mobxStore: MobxRootStore;

  private _translations: Partial<Record<IApiUserClientSideTranslationKey, string>> = {};
  private _loading = false;

  constructor(mobxStore: MobxRootStore) {
    this.mobxStore = mobxStore;
    makeAutoObservable(this);
  }

  fetchTranslations = async (language?: string) => {
    this._loading = true;
    try {
      const { data } = await apiUserClientSideTranslations.getAll(language);

      const newTranslations: Record<string, string> = {};

      data.forEach((item) => {
        newTranslations[item.key] = item.value;
      });

      runInAction(() => {
        this._translations = newTranslations;
      });
    } catch (error) {
      handleError(keyMap.sharedErrorsFailedToGetData);
    } finally {
      runInAction(() => {
        this._loading = false;
      });
    }
  };

  t = (key: IApiUserClientSideTranslationKey) => {
    const translationValue = this._translations[key];

    return translationValue || key;
  };

  get clientSideTranslationsLoading() {
    return this._loading;
  }
}
